import { Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { BrandingProvider } from './contexts/BrandingContext'
import { TaxonomyProvider } from './contexts/TaxonomyContext'
import { RoleProvider } from './contexts/RoleContext'
import Login from './pages/Login'
import ResearcherLayout from './components/layout/ResearcherLayout'
import AdminLayout from './components/layout/AdminLayout'
import Landing from './pages/researcher/Landing'
import SearchResults from './pages/researcher/SearchResults'
import Browse from './pages/researcher/Browse'
import Connections from './pages/researcher/Connections'
import ResourceDetail from './pages/researcher/ResourceDetail'
import MyLists from './pages/researcher/MyLists'
import SharedWithMe from './pages/researcher/SharedWithMe'
import Settings from './pages/researcher/Settings'
import ManualAdd from './pages/researcher/ManualAdd'
import MendeleySync from './pages/researcher/MendeleySync'
import AdminDashboard from './pages/admin/Dashboard'
import Branding from './pages/admin/Branding'
import Moderation from './pages/admin/Moderation'
import UserManagement from './pages/admin/UserManagement'
import AuditLog from './pages/admin/AuditLog'
import SubjectManagement from './pages/admin/SubjectManagement'

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <BrandingProvider>
        <TaxonomyProvider>
          <RoleProvider>
            <Routes>
              <Route path="/login" element={<Login />} />

              {/* Researcher routes */}
              <Route element={<ResearcherLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/connections" element={<Connections />} />
                <Route path="/resource/:id" element={<ResourceDetail />} />
                <Route path="/lists" element={<MyLists />} />
                <Route path="/shared" element={<SharedWithMe />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/add" element={<ManualAdd />} />
                <Route path="/mendeley" element={<MendeleySync />} />
              </Route>

              {/* Admin routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="branding" element={<Branding />} />
                <Route path="subjects" element={<SubjectManagement />} />
                <Route path="moderation" element={<Moderation />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="audit" element={<AuditLog />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </RoleProvider>
        </TaxonomyProvider>
      </BrandingProvider>
    </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
